export const AppActionType = {
  UPDATE_CURRENT_ACT: 'APP.UPDATE_CURRENT_ACT',
  UPDATE_CURRENT_ACT_SONG: 'APP.UPDATE_CURRENT_ACT_SONG',
  UPDATE_MUTED: 'APP.UPDATE_MUTED',
  UPDATE_NETWORK_SPEED: 'APP.UPDATE_NETWORK_SPEED',
  UPDATE_CURRENT_POINTER: 'APP.UPDATE_CURRENT_POINTER',
  BACKUP_CURRENT_CAMERA: 'APP.BACKUP_CURRENT_CAMERA'
}
